<template>
    <!--弹窗-->
    <el-dialog
        v-if="visible"
        width="900px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div class="chart-datepicker">
            <div
                class="range-option"
                @click="getList(charts_id, 30)"
                :style="index == 30 ? 'font-weight: bold;color: #508cfd;' : ''"
            >
                30 天
            </div>
            <div
                class="range-option"
                @click="getList(charts_id, 90)"
                :style="index == 90 ? 'font-weight: bold;color: #508cfd;' : ''"
            >
                90 天
            </div>
            <div
                class="range-option"
                @click="getList(charts_id, 180)"
                :style="index == 180 ? 'font-weight: bold;color: #508cfd;' : ''"
            >
                180天
            </div>
            <div
                class="range-option"
                @click="getList(charts_id, 365)"
                :style="index == 365 ? 'font-weight: bold;color: #508cfd;' : ''"
            >
                1 年
            </div>
			<el-button @click="showData = !showData" style="margin-left:20px" 
                    size="small">
				图表切换
			</el-button>
        </div>
        <div
            v-loading="loading"
			v-show="!showData"
            :id="'highcharts-' + charts_id"
            style="min-height: 400px;"
        ></div>
		<div style="height:400px;overflow:auto" v-show="showData">
			<div style="position:absolute;z-index:999;top:116px;width: 853px;height:38px;overflow:auto">
				<el-table
				    v-loading="loading"
				    :data="list"
				    class="table_content"
				    size="mini"
				    border
					height="38"
				    style="width: 100%;">
				    <el-table-column 
						type="index"
						label="序号"
						width="80">
				    </el-table-column>
				    <el-table-column
				        label="日期"
				        :resizable="false"
				        align="center">
				    </el-table-column>
					<el-table-column
					    label="你的产品"
					    :resizable="false"
					    align="center">
					</el-table-column>
				</el-table>
			</div>
			<el-table
			    v-loading="loading"
			    :data="list"
			    class="table_content"
			    size="mini"
			    border
			    style="width: 100%;">
			    <el-table-column 
					type="index"
					label="序号"
					width="80">
			    </el-table-column>
			    <el-table-column
			        label="日期"
					prop="date"
			        :resizable="false"
			        align="center">
			    </el-table-column>
				<el-table-column
				    label="你的产品"
					prop="val1"
				    :resizable="false"
				    align="center">
				</el-table-column>
			</el-table>
		</div>
        <el-divider></el-divider>
        <div class="phrase-stats">
            <div>
                最高排名:
                <div class="stat-top-info" v-if="min_num != null">
                    <span>{{ min_num }}</span>
                    <span>( {{ min_date }} )</span>
                </div>
                <span v-else> - </span>
            </div>
            <div>
                最低排名:
                <div class="stat-top-info" v-if="max_num != null">
                    <span>{{ max_num }}</span>
                    <span>( {{ max_date }} )</span>
                </div>
                <span v-else> - </span>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import * as Highcharts from "highcharts";
import * as loadExporting from "highcharts/modules/exporting";
import * as exportExcel from "highcharts/modules/export-data.src";
loadExporting(Highcharts);
exportExcel(Highcharts);
const excludeValue = 100;
export default {
    data() {
        return {
            loading: false,
            index: 0,
            max_num: null,
            max_date: null,
            min_num: null,
            min_date: null,
            is_top_obj: {},
            page_obj: {},
			list:[],
			showData: false
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        charts_id: {
            type: String,
            default: "0"
        },
        charts_keyword: {
            type: String,
            default: ""
        }
    },
    methods: {
        //最小值
        math_Max_Min(date, rank) {
            let max_num = null;
            let max_date = date[0];
            let min_num = null;
            let min_date = date[0];
            for (let i = 1; i < rank.length; i++) {
                if (rank[i] != null) {
                    if (
                        (rank[i] > max_num || max_num == null) &&
                        rank[i] != excludeValue
                    ) {
                        max_num = rank[i];
                        max_date = date[i];
                    }
                    if (
                        (min_num == null || min_num > rank[i]) &&
                        rank[i] != excludeValue
                    ) {
                        min_num = rank[i];
                        min_date = date[i];
                    }
                }
            }
            this.max_num = max_num;
            this.max_date = max_date;
            this.min_num = min_num;
            this.min_date = min_date;
        },
        getList(id, index) {
            if (this.index == index) return;
            this.index = index;
            this.loading = true;
            api.trend_batch({ keyword_ids: [id], days: index, is_ad: 1 })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        let res_date = res.data[id].date;
                        const rankList = res.data[id].rank.map(item => {
                            if (item == -1) {
                                item = null;
                                // item = excludeValue;
                            }
                            return item;
                        });
                        this.math_Max_Min(res_date, rankList);
                        // let is_top_obj = {};
                        let page_obj = {};
                        for (let i = 0; i < res_date.length; i++) {
                            // is_top_obj[res_date[i]] = res.data[id].is_top[i];
                            page_obj[res_date[i]] = res.data[id].page[i];
                        }
                        // this.is_top_obj = is_top_obj;
                        this.page_obj = page_obj;
                        this.getCharts(res_date, rankList);
						
						this.list = [];
						for(let k = 0; k < res.data[id].date.length; k++){
							this.list.push({
								date:res.data[id].date[k],
								val1:res.data[id].rank[k]===-1?"排名外":res.data[id].rank[k],
							})
						}
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getCharts(date, data) {
            let that = this;
            Highcharts.chart("highcharts-" + this.charts_id, {
                chart: {
                    type: "line"
                },
                title: {
                    text: null
                },
                yAxis: {
                    allowDecimals: false,
                    reversed: true,
                    min: 1,
                    max: 110,
                    title: {
                        text: null
                    }
                },
                xAxis: {
                    categories: date,
                    title: {
                        text: "DateTime"
                    },
                    tickInterval: Math.ceil(date.length / 6),
                    tickWidth: 1
                },
                tooltip: {
                    crosshairs: [
                        {
                            width: 1,
                            color: "#ddd"
                        }
                    ],
                    formatter: function() {
                        var s =
                            "<div style='font-weight: 900;'>" +
                            this.x +
                            "</div>";
                        if (this.y == excludeValue) {
                            s +=
                                "<br/><br/>" +
                                "<div style='font-weight: 900;'>排名外</div>";
                            return s;
                        }
                        s +=
                            "<br/><br/>" +
                            "<div style='color: rgb(134, 178, 234) !important;'>你的产品</div><br/>排名: <b>" +
                            this.y +
                            `</b><br/>页数:<b>
                                ${that.page_obj[this.x]}
                                </b>
                            </div><br/>`;
                        // s +=
                        //     "<br/><br/>" +
                        //     "<div style='color: rgb(134, 178, 234) !important;'>你的产品</div><br/>排名: <b>" +
                        //     this.y +
                        //     `</b><br/>页数:<b>
                        //         ${that.page_obj[this.x]}
                        //         </b><br/><div style='color: #e47911 !important;'>
                        //         ${that.is_top_obj[this.x] == 1 ? "top" : ""}
                        //         </div>
                        //     </div><br/>`;
                        return s;
                    }
                    // pointFormat: `<br/><div style="color: rgb(134, 178, 234) !important;">你的产品</div><br/>排名: <b>{point.y}</b><br/><br/>`
                },
                plotOptions: {
                    series: {
                        cursor: "pointer",
                        label: {
                            connectorAllowed: false
                        },
                        events: {
                            click: function(event) {
                                // console.log(event.point.options);
                                console.log(event.point);
                            }
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                credits: { enabled: false },
                series: [{ data: data, name: "排名" }],
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom"
                                }
                            }
                        }
                    ]
                },
                exporting: {
                    filename: `${this.title} (数据统计图)`,
                    menuItemDefinitions: {
                        printChart: {
                            text: "打印图表"
                        },
                        downloadJPEG: {
                            text: "下载JPEG 图片"
                        },
                        downloadPDF: {
                            text: "下载PDF 文档"
                        },
                        downloadPNG: {
                            text: "下载PNG 图片"
                        },
                        downloadSVG: {
                            text: "下载SVG 矢量图"
                        },
                        exportButtonTitle: {
                            text: "导出图片"
                        },
                        downloadCSV: {
                            text: "下载CSV 数据表"
                        },
                        downloadXLS: {
                            text: "下载XLS 数据表"
                        }
                    },
                    buttons: {
                        contextButton: {
                            menuItems: [
                                "printChart",
                                "separator",
                                "downloadJPEG",
                                "downloadPDF",
                                "downloadPNG",
                                "downloadSVG",
                                "separator",
                                "downloadCSV",
                                "downloadXLS"
                            ]
                        }
                    }
                }
            });
        },
        // 关闭弹窗
        handleClose() {
            this.index = 0;
            this.max_num = null;
            this.max_date = null;
            this.min_num = null;
            this.min_date = null;
            this.loading = false;
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.chart-datepicker {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    margin-bottom: 20px;
}
.range-option {
    font-size: 13px;
    color: #3a3a3a;
    padding: 0 10px;
    text-decoration: underline;
    cursor: pointer;
}
.range-option:hover {
    color: #666;
    text-decoration: none;
}
.phrase-stats {
    margin-left: 10px;
    margin-bottom: 10px;
    div {
        line-height: 30px;
        font-weight: 700;
        font-size: 16px;
    }
    span {
        margin-right: 5px;
    }
}
.stat-top-info {
    display: inline-block;
}
/deep/ .el-dialog__body {
    padding: 10px 20px 20px 20px !important;
}
</style>
